import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "reactstrap";

// redux
import { shallowEqual, useDispatch, useSelector } from "react-redux";

// sayfalar, modallar vs.
import UserTable from "./UserTable";
import { fetchUserRoles, fetchUsers } from "../../slices/apps/userSlice";

const Users = () => {
  document.title = "Kullanıcılar | Metiner Avantaj+";

  const dispatch = useDispatch();

  // states
  const [loading, setLoading] = useState(true);

  const { usersRefresh } = useSelector((state) => {
    return {
      usersRefresh: state.user.usersRefresh,
    };
  }, shallowEqual);

  const fetchData = async () => {
    setLoading(true);

    try {
      await dispatch(fetchUsers());
      await dispatch(fetchUserRoles());
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, usersRefresh]);

  if (loading) {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "50vh" }}
            >
              <Spinner color="primary">Yükleniyor...</Spinner>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xs={12}>
              <UserTable />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Users;
